module.exports = __webpack_public_path__ + "img/catalonia_export_analysis.319233d2.png";